import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { SITE_CONTENT } from "../content";
import bHero from "../assets/blog/blog_hero_banner.png"; // reusing the premium banner image

// Inline SVGs for elegant UI
const LocationIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="24" height="24">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
    <circle cx="12" cy="9" r="2" />
  </svg>
);

const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="20" height="20">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const MailIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="20" height="20">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

const ClockIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="20" height="20">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const OrderIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="14" height="14">
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M9 17h6M9 13h6M9 9h6" />
  </svg>
);

const MapPinSmall = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="14" height="14">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-10a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const ContactPage = () => {
  const { global } = SITE_CONTENT;
  
  const [activeTab, setActiveTab] = useState("Salem");
  
  // Form State
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: ""
  });
  const [submitStatus, setSubmitStatus] = useState("");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.subject || !formData.message) {
      setSubmitStatus("error");
      return;
    }
    setSubmitStatus("success");
    setFormData({
      name: "",
      email: "",
      phone: "",
      subject: "",
      message: ""
    });
  };

  // Branch detailed structures
  const branches = [
    {
      id: "Salem",
      name: "Salem Branch",
      address: "Alagapuram Pudur, Salem, Tamil Nadu, 636016",
      phone: "+91 91502 99336",
      hours: "11:00 AM - 11:00 PM",
      swiggy: global.orderLocations?.Salem?.swiggy,
      zomato: global.orderLocations?.Salem?.zomato,
      mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3907.4116035252875!2d78.11894451000001!3d11.6652494!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3babf038f42ef229%3A0xe54e3d09a0618037!2sAlagapuram%20Pudur%2C%20Salem%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1717431600000!5m2!1sen!2sin",
      gMapLink: "https://maps.google.com/?q=Alagapuram+Pudur+Salem"
    },
    {
      id: "Coimbatore",
      name: "Coimbatore Branch",
      address: "Saibaba Colony, Coimbatore, Tamil Nadu, 641011",
      phone: "+91 91502 99336",
      hours: "11:00 AM - 11:00 PM",
      swiggy: global.orderLocations?.Coimbatore?.swiggy,
      zomato: global.orderLocations?.Coimbatore?.zomato,
      mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3916.1408891040854!2d76.9427357!3d11.0280962!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba85854fa16b0df%3A0x6002f23cf0d96d2!2sSaibaba%20Colony%2C%20Coimbatore%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1717431650000!5m2!1sen!2sin",
      gMapLink: "https://maps.google.com/?q=Saibaba+Colony+Coimbatore"
    },
    {
      id: "Erode",
      name: "Erode Branch",
      address: "Edayankattuvalasu, Erode, Tamil Nadu, 638011",
      phone: "+91 91502 99336",
      hours: "11:00 AM - 11:00 PM",
      swiggy: global.orderLocations?.Erode?.swiggy,
      zomato: global.orderLocations?.Erode?.zomato,
      mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3912.21330386762!2d77.7126135!3d11.3556093!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba96f264ab4a753%3A0xb3de2271810ab2c4!2sEdayankattuvalasu%2C%20Erode%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1717431700000!5m2!1sen!2sin",
      gMapLink: "https://maps.google.com/?q=Edayankattuvalasu+Erode"
    }
  ];

  const currentActiveBranch = branches.find(b => b.id === activeTab);

  return (
    <div className="rest-page">
      <Header />
      
      {/* Contact Banner */}
      <section 
        className="rest-contact-banner" 
        style={{ backgroundImage: `url(${bHero})` }}
      >
        <div className="max-w-7xl mx-auto">
          <h1>Contact Us</h1>
          <div className="rest-contact-breadcrumbs">
            <Link to="/">Home</Link>
            <span>/</span>
            <span>Contact Us</span>
          </div>
        </div>
      </section>

      {/* Main Container */}
      <main className="rest-contact-container">
        
        {/* Branches Intro */}
        <h2 className="rest-contact-sec-title">Our Branches</h2>
        <p className="rest-contact-sec-desc">
          Drop by any of our branches in Tamil Nadu to grab some hot, crunchy flakes fried chicken, or order directly online through Swiggy and Zomato!
        </p>

        {/* Branch Cards Grid */}
        <div className="rest-branches-grid">
          {branches.map((b) => (
            <div key={b.id} className="rest-branch-card">
              <div className="rest-branch-icon-wrap">
                <LocationIcon />
              </div>
              <h3 className="rest-branch-name">{b.name}</h3>
              <p className="rest-branch-detail-text">
                <strong>Address:</strong> {b.address}
                <br /><br />
                <strong>Hours:</strong> {b.hours}
                <br />
                <strong>Phone:</strong> {b.phone}
              </p>
              
              <div className="rest-branch-cta-buttons">
                {b.swiggy && (
                  <a href={b.swiggy} target="_blank" rel="noopener noreferrer" className="rest-branch-order-btn">
                    <OrderIcon />
                    Order on Swiggy
                  </a>
                )}
                <a href={b.gMapLink} target="_blank" rel="noopener noreferrer" className="rest-branch-direction-btn">
                  <MapPinSmall />
                  Get Directions
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Contact Info Panel and Form Row */}
        <div className="rest-contact-row">
          
          {/* Contact Details Info */}
          <div className="rest-contact-info-panel">
            <h3 className="rest-info-panel-title">Get In Touch</h3>
            <p className="rest-info-panel-desc">
              Have questions, feedback, or catering requests? Contact our customer support team directly or send us a message through the contact form.
            </p>

            <div className="rest-info-detail-list">
              <div className="rest-info-detail-item">
                <div className="rest-info-detail-icon">
                  <PhoneIcon />
                </div>
                <div className="rest-info-detail-content">
                  <h4>Call Us</h4>
                  <a href={`tel:${global.topBar?.phone || "+919150299336"}`}>
                    {global.topBar?.phone || "+91 91502 99336"}
                  </a>
                </div>
              </div>

              <div className="rest-info-detail-item">
                <div className="rest-info-detail-icon">
                  <MailIcon />
                </div>
                <div className="rest-info-detail-content">
                  <h4>Email Us</h4>
                  <a href={`mailto:${global.topBar?.email || "flakesfriedchicken17@gmail.com"}`}>
                    {global.topBar?.email || "flakesfriedchicken17@gmail.com"}
                  </a>
                </div>
              </div>

              <div className="rest-info-detail-item">
                <div className="rest-info-detail-icon">
                  <ClockIcon />
                </div>
                <div className="rest-info-detail-content">
                  <h4>Working Hours</h4>
                  <p>Daily: 11.00 AM - 11.00 PM</p>
                </div>
              </div>
            </div>
          </div>

          {/* Message Form */}
          <div className="rest-contact-form-panel">
            <h3 className="rest-info-panel-title">Send Us A Message</h3>
            
            {submitStatus === "success" && (
              <div className="bg-emerald-50 text-emerald-800 border border-emerald-200 px-4 py-3 rounded-md mb-6 text-sm">
                Thank you! Your message has been submitted successfully. We will get back to you shortly.
              </div>
            )}
            {submitStatus === "error" && (
              <div className="bg-rose-50 text-rose-800 border border-rose-200 px-4 py-3 rounded-md mb-6 text-sm">
                Please fill out all required fields before submitting.
              </div>
            )}

            <form onSubmit={handleFormSubmit}>
              <div className="rest-form-grid" style={{ marginBottom: "0" }}>
                <div style={{ marginBottom: "20px" }}>
                  <input 
                    type="text" 
                    name="name" 
                    placeholder="Your Name *" 
                    className="rest-form-input"
                    value={formData.name}
                    onChange={handleChange}
                    required 
                  />
                </div>
                <div style={{ marginBottom: "20px" }}>
                  <input 
                    type="email" 
                    name="email" 
                    placeholder="Your Email *" 
                    className="rest-form-input"
                    value={formData.email}
                    onChange={handleChange}
                    required 
                  />
                </div>
                <div style={{ marginBottom: "20px" }}>
                  <input 
                    type="text" 
                    name="phone" 
                    placeholder="Phone Number (Optional)" 
                    className="rest-form-input"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>
                <div style={{ marginBottom: "20px" }}>
                  <input 
                    type="text" 
                    name="subject" 
                    placeholder="Subject *" 
                    className="rest-form-input"
                    value={formData.subject}
                    onChange={handleChange}
                    required 
                  />
                </div>
                <div style={{ gridColumn: "span 2", marginBottom: "25px" }}>
                  <textarea 
                    name="message" 
                    rows="6" 
                    placeholder="Write your message here... *" 
                    className="rest-form-textarea"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
              </div>
              <button type="submit" className="rest-reply-submit-btn">
                Send Message
              </button>
            </form>
          </div>

        </div>

        {/* Map tab switcher section */}
        <div className="rest-map-switcher-sec">
          <h2 className="rest-contact-sec-title">Find Us On Map</h2>
          
          {/* Map Tabs Selector */}
          <div className="rest-map-tabs">
            {branches.map((b) => (
              <button
                key={b.id}
                onClick={() => setActiveTab(b.id)}
                className={`rest-map-tab-btn${activeTab === b.id ? " active" : ""}`}
              >
                {b.name}
              </button>
            ))}
          </div>

          {/* Embedded responsive map frame */}
          <div className="rest-map-iframe-container">
            <iframe 
              src={currentActiveBranch.mapUrl} 
              title={currentActiveBranch.name} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>

      </main>

      <Footer />
    </div>
  );
};

export default ContactPage;
